export enum PublicationType {
    Video,
    Audio,
    Document,
    Link,
    Embeded,
    Image
}
